import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5e3ccf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "onboarding-layout" }

import { inject, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { VueCookies } from 'vue-cookies';

import setHeadTitle from '@/helper/setHeadTitle';
import { useStore } from '@/store';
import { amplitudeInstance } from '@/analytics';

import BaseLoader from '@/components/BaseLoader.vue';
import TheError from '@/components/TheError.vue';
import OnboardingFooter from './OnboardingFooter.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingLayout',
  setup(__props) {

const { t } = useI18n();
const route = useRoute();
const store = useStore();
const cookies = inject<VueCookies>('$cookies');
const isFetching = ref<boolean>(true);
const isFetchError = ref<boolean>(false);

setHeadTitle(t('page_onboarding_head_title'));

const logSessionEvent = function logSessionEvent(status: string) {
  const isAnalyticCookie = cookies?.get('AnalyticSessionCookies');

  if (!isAnalyticCookie) {
    amplitudeInstance.logEvent('Session_start', {
      user_status: status,
    });

    cookies?.set('AnalyticSessionCookies', true, 60 * 30); // 30 min
  }
};

onMounted(async () => {
  logSessionEvent('not_authorized');

  try {
    await store.dispatch('onboarding/getQuestions', null);
    await store.dispatch('onboarding/getSubscriptions', null);
  } catch (error) {
    isFetchError.value = true;
  } finally {
    isFetching.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isFetching.value)
      ? (_openBlock(), _createBlock(BaseLoader, {
          key: 0,
          class: "onboarding-layout__loader"
        }))
      : (isFetchError.value)
        ? (_openBlock(), _createBlock(TheError, {
            key: 1,
            class: "onboarding-layout__error"
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_router_view, {
              class: _normalizeClass({
          'onboarding-layout__main': true,
          'onboarding-layout__main--with-footer': _unref(route).meta.showFooter,
        })
            }, null, 8, ["class"]),
            (_unref(route).meta.showFooter)
              ? (_openBlock(), _createBlock(OnboardingFooter, {
                  key: 0,
                  class: "onboarding-layout__footer"
                }))
              : _createCommentVNode("", true)
          ], 64))
  ]))
}
}

})